<h2 mat-dialog-title>{{ isEdit ? 'Edit Coupon / Gavekort' : 'Add Coupon / Gavekort' }}</h2>

<mat-dialog-content>
  <form [formGroup]="form">

    <div class="code-row">
      <mat-form-field appearance="outline" class="code-field">
        <mat-label>Code</mat-label>
        <input matInput formControlName="code" placeholder="e.g. N5VT" style="text-transform:uppercase">
        <mat-error *ngIf="form.get('code').hasError('required')">Code is required</mat-error>
        <mat-error *ngIf="form.get('code').hasError('pattern')">Use exactly 4 uppercase letters or numbers, with at least 1 number</mat-error>
      </mat-form-field>
      <button mat-stroked-button type="button" (click)="generateCode()" *ngIf="!isEdit" class="generate-btn">
        <mat-icon>casino</mat-icon> Generate
      </button>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Description (internal note)</mat-label>
      <input matInput formControlName="description" placeholder="Optional internal note">
    </mat-form-field>

    <div class="two-col">
      <mat-form-field appearance="outline">
        <mat-label>Value (NOK)</mat-label>
        <input matInput type="number" formControlName="discountValue" min="1">
        <mat-error *ngIf="form.get('discountValue').hasError('required')">Value is required</mat-error>
        <mat-error *ngIf="form.get('discountValue').hasError('min')">Minimum value is 1</mat-error>
        <mat-error *ngIf="form.get('discountValue').hasError('max')">
          Maximum gavekort value is NOK {{ maxStoredValueAmount }}
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Min Order Amount (NOK)</mat-label>
        <input matInput type="number" formControlName="minOrderAmount" min="0">
        <mat-hint>0 = no minimum</mat-hint>
      </mat-form-field>
    </div>

    <div class="two-col">
      <mat-form-field appearance="outline">
        <mat-label>Valid From</mat-label>
        <input matInput [matDatepicker]="pickerFrom" formControlName="validFrom">
        <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
        <mat-datepicker #pickerFrom></mat-datepicker>
        <mat-error *ngIf="form.get('validFrom').hasError('required')">Valid from date is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Valid Until</mat-label>
        <input matInput [matDatepicker]="pickerUntil" formControlName="validUntil">
        <mat-datepicker-toggle matSuffix [for]="pickerUntil"></mat-datepicker-toggle>
        <mat-datepicker #pickerUntil></mat-datepicker>
        <mat-error *ngIf="form.get('validUntil').hasError('required')">Valid until date is required</mat-error>
      </mat-form-field>
    </div>

    <div class="toggles-row">
      <div class="toggle-item">
        <mat-slide-toggle formControlName="isActive" color="primary">Active</mat-slide-toggle>
      </div>
    </div>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="form.invalid">
    {{ isEdit ? 'Save' : 'Create' }}
  </button>
</mat-dialog-actions>
